export const BUYER_CREDIT_DATA='BUYER_CREDIT_DATA';
export const BUYER_CREDIT_REPAY_DATA='BUYER_CREDIT_REPAY_DATA';
export const BUYER_CREDIT_DETAIL_DATA ='BUYER_CREDIT_DETAIL_DATA'